var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', _vm._g(_vm._b({
    attrs: {
      "content-class": "fill-height",
      "value": _vm.value,
      "width": "500"
    }
  }, 'dialog-scroll-lock', _vm.$attrs, false), _vm.$listeners), [_c('v-card', {
    staticClass: "d-flex flex-column fill-height"
  }, [_c('v-card-title', {
    staticClass: "flex-grow-0"
  }, [_vm._v(" Add GIF / sticker "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mt-n1 mr-n3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1)], 1), _c('v-card-subtitle', {
    staticClass: "flex-grow-0"
  }, [_vm._v(" Powered by Tenor ")]), _c('div', {
    staticClass: "flex-grow-0 px-3"
  }, [_c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "clearable": "",
      "label": "Search"
    },
    on: {
      "click:clear": function () {
        _vm.textStaged = null;
        _vm.isDirty && _vm.search();
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function () {
          return _vm.isDirty && _vm.search();
        }.apply(null, arguments);
      }
    },
    model: {
      value: _vm.textStaged,
      callback: function ($$v) {
        _vm.textStaged = $$v;
      },
      expression: "textStaged"
    }
  }), _c('v-btn', {
    staticClass: "ml-4",
    class: {
      'primary pulse': _vm.isDirty
    },
    attrs: {
      "small": "",
      "fab": "",
      "disabled": !_vm.isDirty,
      "loading": _vm.searchStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.search();
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMagnify)
    }
  })], 1)], 1), _c('div', {
    staticClass: "mt-2 mb-n1 pb-6 mx-n1"
  }, [_c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "rounded": "",
      "color": _vm.stickers ? null : 'primary'
    },
    on: {
      "click": function ($event) {
        _vm.stickers = false;
        _vm.search(true);
      }
    }
  }, [_vm._v("GIFs")]), _c('v-btn', {
    staticClass: "ma-1",
    attrs: {
      "rounded": "",
      "color": _vm.stickers ? 'primary' : null
    },
    on: {
      "click": function ($event) {
        _vm.stickers = true;
        _vm.search(true);
      }
    }
  }, [_vm._v("Stickers")])], 1)]), _c('div', {
    ref: "items-container",
    staticClass: "flex-grow-1 pa-3 overflow-y-auto"
  }, [_c('div', {
    staticStyle: {
      "column-count": "3",
      "column-gap": "12px"
    }
  }, _vm._l(_vm.items, function (item) {
    return _c('img', {
      key: item.id,
      staticClass: "mb-3 d-block hover",
      staticStyle: {
        "width": "100%",
        "max-width": "100%"
      },
      style: {
        'aspect-ratio': _vm.getPreviewMedia(item).dims[0] / _vm.getPreviewMedia(item).dims[1]
      },
      attrs: {
        "src": _vm.proxy(_vm.getPreviewMedia(item).url)
      },
      on: {
        "error": function ($event) {
          _vm.global.proxyTenor = true;
        },
        "click": function ($event) {
          return _vm.select(item);
        }
      }
    });
  }), 0), _vm.next ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    directives: [{
      name: "intersect",
      rawName: "v-intersect.quiet",
      value: function (entries) {
        return (entries[0] || {}).isIntersecting && _vm.search();
      },
      expression: "entries => (entries[0] || {}).isIntersecting && search()",
      modifiers: {
        "quiet": true
      }
    }],
    staticClass: "my-3",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e()])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }